import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Input } from '@chakra-ui/react'
import { Button, ButtonGroup } from '@chakra-ui/react'
import axios from "axios"
import { useSelector ,useDispatch} from "react-redux";
import { getmyinfoAction } from '../../../../../../redux/reducer/getmyinfo/action/action';
import { useToast } from '@chakra-ui/react'
import "./mydatamodal.css"
import FormData from 'form-data';
import { getMyImageAction } from '../../../../../../redux/reducer/getMyimg/action/action';
import "./mydatamodalDark.css"
import sockets from '../../../../../../socket/socket';

const socket = sockets
export default function MydataModal({data}) {

  const myinfo = useSelector(data=> data.getMayInfoReducer.myinfo)
  const [show, setShow] = useState(false);
  const [isSend, setisSend] = useState(false);
  const [loading,setLoading] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch()
  const [selectedFile, setSelectedFile] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [imgURL, setimgURL] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const toast = useToast()

  const myinfos = useSelector(data=> data.getMyImageReducer);
  const getDarkModoe = useSelector(darkModes => darkModes )
  let getCompanyID = useSelector(compID => compID.checkedSessionReducer)
  useEffect(()=>{
        const myVisit = localStorage.getItem("myVisit");
   

      if (myVisit === null) {
        handleShow()
        localStorage.setItem("myVisit", true);
      }
    dispatch(getmyinfoAction("/registration/v2/api"))

     
},[dispatch,isSend])





const updateData=(e)=>{

  setisSend(true)
    e.preventDefault()
    setLoading(true)


  axios.patch('/update/data/v2', {
    data:{
      name: e.target.name.value,
      email:e.target.email.value,
      tel:e.target.tel.value,
      telegram:e.target.telegram.value,
      WhatsApp:e.target.WhatsApp.value,
    }
  })
  .then(function (response) {
  
    setLoading(false)
    setisSend(false)
    dispatch(getmyinfoAction("/registration/v2/api"))
    dispatch(getMyImageAction("/registration/v2/api"))
    setImgUrl('')
    // update in task my data
    axios.post('/updateMydataInTask/api', {
        myinfo:{
          name: e.target.name.value,
          email:e.target.email.value,
          tel:e.target.tel.value,
         
            }
    })
    .then(function (response) {
      console.log(response);
      console.log(response);
      // update sockets
      socket.emit('getallTaskforUpdateServer');
    })
    .catch(function (error) {
      console.log(error);
    });
  })
  .catch(function (error) {
    console.log(error);
    setLoading(false)
    toast({
      title: 'Ошибка',
      description:error.response.data.message,
      status: "error",
      duration: 3000,
      isClosable: true,
      position:"top"
    })
  });




  const formData = new FormData();
    formData.append('image', selectedFile);
    
// здесь мы загружаем наше изображение на сервер
// здесь мы загружаем наше изображение на сервер
if (selectedFile.size <= 5 * 1024 * 1024) {
  try {
    const response =  axios.post('/upload/myimage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    response.then(data=>{
        console.log(data.data.data);
        setimgURL(data.data.data)
        dispatch(getmyinfoAction("/registration/v2/api"))
        dispatch(getMyImageAction("/registration/v2/api"))
    })
  } catch (error) {
    console.error(error);
  }
}else{
  toast({
    position:"top",
    title: 'Размер изображения не более 5мб, форматы: jpg, png.',
    description: "Размер изображения не более 5мб, форматы: jpg, png.",
    status: 'error',
    duration: 2000,
    isClosable: true,
  })
}
}


const handleUploadIMNG=(e)=>{
  setSelectedFile([]);
  setSelectedFile(e.target.files[0]);
  setImgUrl( URL.createObjectURL(e.target.files[0]))
 

}
const handleTitleChange = (event) => {
  setTitle(event.target.value);
};

const handleDescriptionChange = (event) => {
  setDescription(event.target.value);
};


  return (
   <div className='modalEditCont'>
     
     

                 <button className="editBtnProfile"  onClick={handleShow}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M13.5159 7.35778L14.6402 8.48222L3.56839 19.5556H2.44411V18.4311L13.5159 7.35778ZM17.9153 0C17.6098 0 17.292 0.122222 17.0599 0.354444L14.8235 2.59111L19.4062 7.17444L21.6425 4.93778C22.1192 4.46111 22.1192 3.69111 21.6425 3.21444L18.7829 0.354444C18.5385 0.11 18.233 0 17.9153 0ZM13.5159 3.89889L0 17.4167V22H4.5827L18.0986 8.48222L13.5159 3.89889Z" fill="#3B79F6"/>
                    </svg>
                  </button>
  
     <Modal show={show} onHide={handleClose}>
        <form onSubmit={updateData} className={getDarkModoe.ToggleDarkModeReducer.chekced?"DarkModalEdit":"ligthModal"}>
     <input  type="hidden" onChange={(e)=> setDescription(e.target.value)}></input>
       
     <div className='editMyInfoBody'>
            
          <div className='myAvatars'>
              

            {(() => { 
              if (imgUrl) {
                return  <img src={imgUrl} alt="" className='urlimg' />
              }
            else if (myinfos.users.myavatar) {
              return  <img src={myinfos.users.myavatar} alt="" className='urlimg' />
              }else{
                return <img src={"https://cdn-icons-png.flaticon.com/512/666/666201.png"} alt="" className='urlimg' />
              }
            })()}
                <label htmlFor="upload" className='LabelCont'>
            
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="25" viewBox="0 0 30 25" fill="none">
                <path d="M15.0003 10.3398C12.8973 10.3398 11.1924 12.0596 11.1924 14.1811C11.1924 16.3037 12.8973 18.0224 15.0003 18.0224C17.1034 18.0224 18.8076 16.3037 18.8076 14.1811C18.8076 12.0595 17.1033 10.3398 15.0003 10.3398Z" fill="#AAAAAA"/>
                <path d="M29.1078 5.34761C28.5603 4.79325 27.7889 4.44433 26.9465 4.44433H23.6416C23.3752 4.44538 23.1269 4.28601 23.0125 4.02872L22.0224 1.81236C21.5327 0.714257 20.4441 0 19.2359 0H10.764C9.55633 0 8.46725 0.714257 7.97641 1.81236L6.98735 4.02872C6.87298 4.28601 6.62413 4.44538 6.35829 4.44433H3.05343C2.21156 4.44433 1.43859 4.79319 0.890037 5.34761C0.341484 5.90038 0 6.67288 0 7.51422V21.7367C0 22.5785 0.341484 23.3505 0.890037 23.9032C1.43853 24.4576 2.21156 24.8065 3.05343 24.8054H16.2106H26.9466C27.789 24.8065 28.5604 24.4576 29.1079 23.9032C29.659 23.3505 30 22.5785 30 21.7367V7.51422C29.9999 6.67288 29.659 5.89932 29.1078 5.34761ZM19.8904 19.102C18.6435 20.3626 16.9084 21.1463 15.0003 21.1463C13.091 21.1463 11.3565 20.3627 10.1096 19.102C8.86059 17.8446 8.08645 16.0984 8.08756 14.1807C8.08651 12.2629 8.86059 10.5183 10.1096 9.25879C11.3564 7.99914 13.0905 7.21452 15.0003 7.2161C16.9084 7.21452 18.6435 7.99914 19.8904 9.25879C21.1394 10.5184 21.9135 12.2629 21.9119 14.1807C21.9134 16.0984 21.1394 17.8446 19.8904 19.102ZM27.0683 9.97357H24.9711V7.8758H27.0683V9.97357Z" fill="#AAAAAA"/>
              </svg>
                <input type="file" id='upload' onChange={handleUploadIMNG}  accept="image/*" />
                <input type="text" value={title} onChange={handleTitleChange} />
                <input type="text" value={description} onChange={handleDescriptionChange} />
              
            
            
                
            </label>  
          </div>
           <div className='myinfoText'>
             <p className='name'>{data.name}</p>
              <p className='telInfo'>{data.tel}</p>
              <p className='email'>{data.email}</p>
           </div>
          </div>
          
            <br />
           <div className='myModalInput'>
              <label htmlFor="Имя" style={{margin:"2%"}}>Имя</label>
              <input placeholder='Имя' id='Имя' name='name' defaultValue={data.name} />
            <label htmlFor="email" style={{margin:"2%"}}>Электронная почта</label>
            <input placeholder='Электронная почта' id='email' name='email' defaultValue={data.email} />
            <label htmlFor="tel" style={{margin:"2%"}}>Номер телефона</label>
            <input placeholder='Номер телефона' id='tel' name='tel' type={"number"} defaultValue={data.tel} />
            <label htmlFor="tel" style={{margin:"2%"}}>Telegram</label>
            <input placeholder='@uprosti.rf' id='telegram' name='telegram' type={"text"} defaultValue={data.telegram} />
            <label htmlFor="tel" style={{margin:"2%"}}>WhatsApp</label>
            <input placeholder='+79000000000' id='WhatsApp' name='WhatsApp' type={"text"} defaultValue={data.whatsUp} />
           </div>
        
        
       <div className='sveMyinfoBTN'>
       {loading?
         <Button isLoading colorScheme='teal' backgroundColor={"#5E83E0"} variant='solid'> Сохранить изменения  </Button>
         :
         <Button colorScheme='blue' type={"submit"} backgroundColor={"#5E83E0"} style={{borderRadius:"24px"}} > Сохранить изменения</Button>
         }
       </div>
       </form>
     </Modal>
        
   </div>
  );
}

